module.exports = __webpack_public_path__ + "img/linkEmpty.f295b603.png";